import { useAtomValue } from 'jotai'
import { lastChainIdAtom } from 'src/common/stores/store'
import { getActiveOrDefaultChain } from 'src/common/utils/web3/network'

const useActiveOrDefaultChain = () => {
  const lastChainId = useAtomValue(lastChainIdAtom)
  const defaultValue = getActiveOrDefaultChain(lastChainId)
  return defaultValue
}

export default useActiveOrDefaultChain
